import React from 'react';
import { Box, Stack, Button, Typography } from '@mui/material';

const moduleTypes = [
  'Admin',
  'Clinical',
  'Lab',
  'AI'
];

interface ModuleStepProps {
  selectedModule: string;
  setSelectedModule: (type: string) => void;
}

const ModuleStep: React.FC<ModuleStepProps> = ({
  selectedModule,
  setSelectedModule,
}) => (
  <Box>
    <Typography variant="h6" fontWeight={500} mb={2}>
      Select Module :
    </Typography>
    
    <Stack direction="row" spacing={3}>
      {moduleTypes.map(type => (
        <Button
          key={type}
          variant={selectedModule === type ? 'contained' : 'outlined'}
          color={selectedModule === type ? 'error' : 'inherit'}
          sx={{
            bgcolor: selectedModule === type ? '#FFEBE6' : '#F5F5F5',
            color: selectedModule === type ? '#FF6F61' : '#888',
            minWidth: 180,
            height: 56,
            fontSize: 18,
            fontWeight: selectedModule === type ? 600 : 400,
            borderRadius: 2,
            boxShadow: 'none',
            border: 'none',
            '&:hover': {
              bgcolor: selectedModule === type ? '#FFEBE6' : '#e0e0e0'
            }
          }}
          onClick={() => setSelectedModule(type)}
        >
          {type}
        </Button>
      ))}
    </Stack>
  </Box>
);

export default ModuleStep;
